
import React, { Fragment } from 'react';
import { Col, Form, FormLabel, InputGroup, Row } from 'react-bootstrap';
import Crud from '../../../components/Crud';
import Input from '../../../components/Input';
import config from '../../../config';
import schema from './schema';

const columns = [
  { header: 'Nome', property: 'nome', filter: true },
];

export default function EmendaParlamentarTipoPage() {

  return (
    <Crud
      header='Tipo de Emenda Parlamentar'
      columns={columns}
      path={`${config.api_path}/v1/transparencia/emenda-parlamentar-tipo`}
      rows={20}
      schema={schema}
      form={({ handleChange, values, errors }) => (
        <Fragment>
          <Row>
            <Col md={4}>
              <Form.Group>
                <FormLabel>Nome</FormLabel>
                <InputGroup>
                  <Input.Text
                    id='nome'
                    onChange={handleChange}
                    value={values.nome}
                    isInvalid={errors.nome}
                  />
                </InputGroup>
                <Form.Control.Feedback type='invalid'>{errors.nome}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Fragment>
      )}
    ></Crud>
  );
}
